import { tViews } from "../../../../utils/table";

export const getColumns = () => {
  return [
    {
      id: "source_ip_col",
      prop: "source_ip",
      name: tViews('topclients.column_label.clientIp'),
      sortable: false,
      canResize: true,
      size: 200,
    },
    {
      id: "site_name_col",
      prop: "site_name",
      name: tViews('topclients.column_label.site'),
      sortable: false,
      size: 200,
    },
    {
      id: "display_usage_col",
      prop: "display_usage",
      name: tViews('topclients.column_label.usage'),
      sortable: false,
      size: 200,
    },
    {
      id: "display_tx_usage_col",
      prop: "display_tx_usage",
      name: tViews('topclients.column_label.txUsage'),
      sortable: false,
      size: 150,
    },
    {
      id: "display_rx_usage_col",
      prop: "display_rx_usage",
      name: tViews('topclients.column_label.rxUsage'),
      sortable: false,
      size: 150,
    },
    {
      id: "display_site_usage_percent_col",
      prop: "display_site_usage_percent",
      name: tViews('topclients.column_label.siteUsagePercent'),
      sortable: false,
      size: 125,
    },
    {
      id: "top_used_apps_col",
      prop: "top_used_apps",
      name: tViews('topclients.column_label.topUsedApps'),
      sortable: false,
      size: 200,
    },
    {
      id: "display_top_used_apps_usage_col",
      prop: "display_top_used_apps_usage",
      name: tViews('topclients.column_label.topUsedAppsUsage'),
      sortable: false,
      size: 200,
    },
  ];
};
